module.exports = __webpack_public_path__ + "portal-static/img/image02.3d42b899.jpg";